import type { IGraphSizes } from '../helpers';
import { getColorCode } from '../helpers';

interface ITransitionLabelProps {
    center: { x: number; y: number };
    graphSizes: IGraphSizes;
    label: string;
}

export function TransitionLabel(props: ITransitionLabelProps) {
    const { center, label, graphSizes } = props;

    return (
        <foreignObject
            // ESLint randomly fails when checking this property. It is unclear why.
            // eslint-disable-next-line react/no-unknown-property
            fill={getColorCode('black')}
            height={graphSizes.nodeHeight / 5}
            width={graphSizes.nodeWidth / 2}
            x={center.x - graphSizes.nodeWidth / 4}
            y={center.y - graphSizes.nodeHeight / 10}
        >
            <p
                style={{
                    fontSize: `${graphSizes.nodeHeight / 6}px`,
                    lineHeight: `${graphSizes.nodeHeight / 6}px`,
                    textAlign: 'center',
                }}
            >
                {label}
            </p>
        </foreignObject>
    );
}
